import React from "react";

import PropTypes from "prop-types";
import { Hits, Index, connectStateResults } from "react-instantsearch-dom";

import SearchInstantDropdownResult from "../search_instant_dropdown_result/search_instant_dropdown_result";
import {
  headingStyle,
  hitsStyle,
} from "./search_instant_dropdown_results_list.module.scss";

const HitCount = connectStateResults(({ searchResults }) => {
  const hitCount = searchResults && searchResults.nbHits;
  return (
    <div className={headingStyle}>
      {hitCount} result{hitCount !== 1 ? `s` : ``}
    </div>
  );
});

const SearchResultsList = ({ indices }) => {
  return (
    <>
      {indices.map((index) => {
        return (
          <Index indexName={index.name} key={index.name}>
            <HitCount />
            <Hits
              className={hitsStyle}
              hitComponent={SearchInstantDropdownResult}
            />
          </Index>
        );
      })}
    </>
  );
};

export default SearchResultsList;

SearchResultsList.propTypes = {
  indices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
